/** 与 tools/search-cli 摘要策略一致：命中前后各 40 个 Unicode 标量 */
const SNIPPET_RADIUS = 40;

/**
 * 在正文中定位连续子串并截取摘要
 */
export function makeSnippet(text: string, query: string): string {
  const chars = Array.from(text);
  const qChars = Array.from(query.trim());

  if (qChars.length === 0) {
    return chars.slice(0, SNIPPET_RADIUS * 2 + 1).join("");
  }

  outer: for (let i = 0; i <= chars.length - qChars.length; i++) {
    for (let j = 0; j < qChars.length; j++) {
      if (chars[i + j] !== qChars[j]) continue outer;
    }
    const from = Math.max(0, i - SNIPPET_RADIUS);
    const to = Math.min(chars.length, i + qChars.length + SNIPPET_RADIUS);
    return chars.slice(from, to).join("");
  }

  return chars.slice(0, SNIPPET_RADIUS * 2 + 1).join("");
}
